import { ScheduleAssessmentPayload } from '@/features/schedule_assessments/models/Students';
import graphqlRequest from '@/services/weeklyPlanner/assignmentRequest';

const ADD_BATCH_ASSIGNMENTS = `mutation batchAddAssignment($entityIdList: [ID!]!, $entityType: Entity!, $assignmentType: String, $manifest: [AssignmentManifestInput], $dateTo: String, $dateFrom: String, $assignor: ID, $grade: Grade) {
    batchAddAssignment(input: {entityIdList: $entityIdList, entityType: $entityType, assignmentType: $assignmentType, manifest: $manifest, dateTo: $dateTo, dateFrom: $dateFrom, assignor: $assignor, grade: $grade}) {
      assignmentId
      assignmentType
      assignor
      createdAt
      status
    }
  }`;

export async function batchAddAssignment(payload: ScheduleAssessmentPayload) {
  return await graphqlRequest(ADD_BATCH_ASSIGNMENTS, payload);
}
